// extracted by mini-css-extract-plugin
export default {"imageRender":"totalDevGraph_imageRender__UuhR6"};